import { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import mutationVariables from '../utility/mutationVariables';
import { ExecuteEtlDocument, GetJobDocument, UpdateEtlDocument } from '../generated/graphql';
var useDestinationUpdate = function (etlId, reload) {
    var _a = useState(''), query = _a[0], setQuery = _a[1];
    var _b = useState(), variables = _b[0], setVariables = _b[1]; //SQL variables
    var _c = useState(), rows = _c[0], setRows = _c[1];
    var _d = useState(false), updating = _d[0], setUpdating = _d[1];
    var _e = useLazyQuery(GetJobDocument, {
        fetchPolicy: 'network-only',
        onCompleted: function (data) {
            if (['FINISHED', 'FAILED'].includes(data.job.state)) {
                setUpdating(false);
                reload();
                return;
            }
            else {
                setTimeout(function () {
                    getJob({ variables: { id: data.job.id } });
                }, 2000);
            }
        },
    }), getJob = _e[0], _f = _e[1], loading = _f.loading, data = _f.data;
    var _g = useMutation(UpdateEtlDocument, {
        onCompleted: function () {
            executeEtl(mutationVariables({ id: etlId }));
        },
    }), updateEtl = _g[0], updateError = _g[1].error;
    var _h = useMutation(ExecuteEtlDocument, {
        onCompleted: function (mutationResponse) {
            setRows(null);
            setUpdating(true);
            getJob({ variables: { id: mutationResponse.executeEtl.id } });
        },
    }), executeEtl = _h[0], executeError = _h[1].error;
    var handleUpdateEtl = function () {
        updateEtl(mutationVariables({
            id: etlId,
            sql: {
                query: query,
                variables: variables,
            },
        }));
    };
    return { updating: updating, handleUpdateEtl: handleUpdateEtl, query: query, setQuery: setQuery, variables: variables, setVariables: setVariables, rows: rows, setRows: setRows };
};
export default useDestinationUpdate;
